import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/general/leftArrow.svg'
import _imports_1 from '../../assets/chat/empty-img-default.svg'


const _withScopeId = n => (_pushScopeId("data-v-00211c24"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "rightContent",
  "element-loading-text": "Loading..."
}
const _hoisted_2 = { class: "leftArrowImg" }
const _hoisted_3 = { class: "firstBox" }
const _hoisted_4 = ["infinite-scroll-disabled"]
const _hoisted_5 = { style: {"height":"100%"} }
const _hoisted_6 = ["element-loading-text"]
const _hoisted_7 = {
  key: 0,
  class: "noMore"
}
const _hoisted_8 = {
  key: 2,
  class: "empty"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "empty-text" }

import { ref, computed, watch, nextTick } from "vue";
import { useStore } from "vuex";
import { getFileLinkApi } from "@/api/chat/index";
import { getMessagesApi } from "@/api/devices/index";
import emitter from "@/utils/eventBus";
import { sendSide } from "@/components/chat/config/chatConfig";
import { isImageOrVideo } from "@/utils/format";
import axios from "axios";
import loading from "@/components/chat/loading.vue";
import { jsonData1 } from '@/mock/message.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'rightContent',
  props: {
  accessTime: {
    type: Array
  }
},
  setup(__props) {

const props = __props;



const store = useStore();


// 控制loading图标是否出现
const contentLoading = ref(false);

// 获取当前激活向的tab名称
const activeTabName = computed(() => {
  return store.state.activeTabName;
});

const deviceId = computed(() => store.state.currentDeviceInfo.id);
const isShowMore750 = computed(() => store.state.isShowMore750);
const isShowMessageLeft = computed(() => store.state.generalAppStore.isShowMessageLeft)


// ===========chatContent============l
const chatLoading = ref(false);
const noMoreChat = ref(false);
const chatPageNum = ref(1); // 页码
let chatGlobalLoading = ref(true);
const disabledChatScroll = computed(
  () => chatLoading.value || noMoreChat.value
);
// 获取当前选中的会话的chat_session_key，向后端请求聊天记录内容
const chat_session_key = computed(() => store.state.clickItemKey);

const sessionClickItemUniqueId = computed(
  () => store.state.sessionClickItem?.unique_id
);

const isVibe = computed(() => !store.state.isVibe);

// 左侧会话列表数据加载失败后触发
emitter.on("closeChatLoading", () => {
  if (activeTabName.value === "first") {
    console.log('closeChatLoading1');

    chatGlobalLoading.value = false;
  }
});

emitter.on("closeLoading", () => {
  if (activeTabName.value !== "first") {
    console.log('closeLoading2');

    chatGlobalLoading.value = false;
  }
});

// 监听左侧列表项被点击,点击后更新右侧聊天记录内容列表数据
watch([sessionClickItemUniqueId], async (oldVal, newVal) => {
  console.log('sessionClickItemUniqueId改变了:', oldVal, newVal);
  // 重置所有数据
  try {
    chatGlobalLoading.value = true
    cumulativeList = []; // 先重置清空原来的聊天列表数据
    chatContentList.value = [];
    chatPageNum.value = 1;
    chatLoading.value = false;
    noMoreChat.value = false;
    // chatGlobalLoading.value = true;
    // 向后端发送请求，获取当前点击项对应的聊天列表内容
    console.log("chat_session_key:", chat_session_key.value);

    if (!chat_session_key.value) {
      console.log('closeLoading3');
      if (!oldVal) {
        chatGlobalLoading.value = false
      }
      return
    }
    await getChatContentList(chat_session_key.value);
    const chatContentDom = document.querySelector("#chatContent") as any;
    if (chatContentDom) {
      chatContentDom.scrollTop = 0; // 让滚动条恢复到最顶部
    }
    // }, 1000)
  } catch (err) {
    console.log(err);
  }
});

let chatContentList = ref<any[]>([]);
// 所有的聊天记录内容
let cumulativeList: any[] = [];

// 根据oos_key获取对应的文件下载地址
const getFileLinkByKey = async (oss_key: any) => {
  const data = {
    oss_key: oss_key,
  };
  try {
    const res = await getFileLinkApi(data);
    // console.log(res, 'getFileLinkByKey');
    if (res.data.code == 200) {
      const fileURL = res.data.data.url;
      return new Promise((resolve, reject) => {
        resolve(fileURL);
      });
    }
  } catch (err) {
    console.log(err);
  }
};
const fileStatus = ref("loading");

// const deviceId = computed(() => store.state.currentDeviceInfo.id)

// 获取聊天列表内容
const getChatContentList = async (key: any, isScroll: boolean = false) => {
  console.log("key:", key)
  chatGlobalLoading.value = true
  try {
    let onePageList: any = [];
    console.log("props:", props);

    let start = props.accessTime![0];
    let end = props.accessTime![1];
    let params
    if (isVibe.value) {
      if (key == "2c624232cdd221771294dfbb310aca000a0df6ac8b66b696d90ef06fdefb64a3") {
        chatContentList.value = jsonData1.data1.messages
      } else if (key == '7902699be42c8a8e46fbbb4501726517e86b22c56a189f7625a6da49081b2451') {
        chatContentList.value = jsonData1.data2.messages
      } else if (key == 'e7f6c011776e8db7cd330b54174fd76f7d0216b612387a5ffcfb81e6f0919683') {
        chatContentList.value = jsonData1.data3.messages
      } else if (key == 'ef2d127de37b942baad06145e54b0c619a1f22327b2ebbcfbec78f5564afe39d') {
        chatContentList.value = jsonData1.data4.messages
      } else if (key == '4b227777d4dd1fc61c6f884f48641d02b4d121d3fd328cb08b5531fcacdabf8a') {
        chatContentList.value = jsonData1.data5.messages
      } else if (key == '4e07408562bedb8b60ce05c1decfe3ad16b72230967de01f640b7e4729b49fce') {
        chatContentList.value = jsonData1.data6.messages
      } else if (key == 'd4735e3a265e16eee03f59718b9b5d03019c07d8b6c51f90da3a666eec13ab35') {
        chatContentList.value = jsonData1.data7.messages
      } else if (key == '6b86b273ff34fce19d6b804eff5a3f5747ada4eaa22f1d49c01e52ddb7875b4b') {
        chatContentList.value = jsonData1.data8.messages
      }
      console.log("chatContentList.value:", chatContentList.value);
      fileStatus.value = "success";
      chatGlobalLoading.value = false;
      return
    } else {
      params = {
        // chat_session_id: 'c574d251-eaca-4ffe-ac17-feb5c417c3bb',
        // device_id: '123456789abc',
        device_id: deviceId.value,
        app: 'native',
        chat_session_id: key,
        start: start,
        // end: 1662260309,
        end: end,
        page: chatPageNum.value,
      };
    }

    let res: any;
    const sourceRef = computed(() => store.state.source);
    // 取消掉上一次请求
    sourceRef.value && sourceRef.value.cancel("请勿频繁请求接口");
    res = await getMessagesApi(params);
    console.log("res:", res);

    if (res.data.code == 200) {
      console.log("res.data.data:", res.data.data);
      onePageList = res.data.data.messages;
      console.log("onePageList:", onePageList);

      // 遍历消息列表，对非文本类型的消息进行特殊处理，通过oss_key向阿里云发请求拿到在线url放入file_url字段中
      const onePageListPromise = onePageList.map(
        async (item: any, index: any) => {
          // if (item.type != chatType.text && item.type != sendSide.systemSide) {
          if (item.oss_key) {
            const fileURL = await getFileLinkByKey(item.oss_key);
            let realType = item.type;
            if (item.type == 9) {
              // 如果是网格图类型，则判断实际是图片还是视频类型
              realType = isImageOrVideo(item.file_name) == "video" ? 3 : 2;
            }
            return {
              ...item,
              file_url: fileURL,
              type: realType,
            };
          } else {
            return item;
          }
        }
      );
      onePageList = await Promise.all(onePageListPromise);
      console.log("res.config.params.chat_session_id:", res.config.params.chat_session_id, chat_session_key.value);

      if (res.config.params.chat_session_id == chat_session_key.value) {
        fileStatus.value = "success";
        cumulativeList = cumulativeList.concat(onePageList);
        chatContentList.value = cumulativeList;
        console.log('6666:', chatContentList.value);
        console.log('closeLoading4');

        chatGlobalLoading.value = false;
        return res.data.data;
      } else {
        console.log('closeLoading5');

        chatGlobalLoading.value = false;
        return {};
      }
    } else {
      console.log('closeLoading6');

      chatGlobalLoading.value = false;
    }
  } catch (err: any) {
    // 这里主要是判断这个错误是取消请求导致的还是其他原因导致的
    if (axios.isCancel(err)) {
      console.log(err.message);
    }
    console.log(err);
    if (
      err.message != "请勿频繁请求接口" &&
      err.message != "请勿频繁请求会话列表接口" &&
      err.message != "请勿频繁请求通讯录列表接口"
    ) {
      // console.log(777);
      console.log('closeLoading7');

      chatGlobalLoading.value = false;
    }
    fileStatus.value = "error";
  }
};

// 获取更多聊天记录内容，滚动到底部时触发该函数
const loadMoreChatContentList = () => {
  // console.log('loadMoreChatContentList');
  if (isVibe.value) return
  chatLoading.value = true;
  setTimeout(async () => {
    try {
      chatPageNum.value++;
      const res: any = await getChatContentList(chat_session_key.value, true);
      chatLoading.value = false;
      // if (chatContentList.value.length % chatPageSize.value != 0) {
      if (chatContentList.value.length >= res.total) {
        noMoreChat.value = true;
      }
    } catch (err) {
      console.log(err);
      chatLoading.value = false;
    }
  }, 100);
};
const currentLang = computed(() => store.state.currentLang);
watch(chatGlobalLoading, (newVal, oldVal) => {
  try {
    if (chatGlobalLoading.value && currentLang.value == "ar") {
      nextTick(() => {
        const loadingText = document.querySelector(".el-loading-text") as any;
        loadingText.style.direction = "rtl";
      });
    }
  } catch (err) {
    console.log(err);
  }
});
const goBackLeftTabs = () => {
  store.commit("setIsShowMessageLeft", true);
}

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        onClick: goBackLeftTabs,
        class: "pointer"
      })
    ], 512), [
      [_vShow, !isShowMore750.value && !isShowMessageLeft.value]
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(chatContentList).length > 0)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "chatContent",
            "infinite-scroll-immediate": false,
            "infinite-scroll-disabled": disabledChatScroll.value,
            "infinite-scroll-distance": "2",
            id: "chatContent"
          }, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatContentList), (item, index) => {
                return _renderSlot(_ctx.$slots, "chatContentItem", {
                  key: index,
                  msgObj: {
            layout: item.send_side == _unref(sendSide).ourSide ? 'right' : 'left',
            message: item,
            fileStatus: fileStatus.value,
          }
                })
              }), 128)),
              _withDirectives(_createElementVNode("div", {
                "element-loading-text": _ctx.$t('chat.loadingText'),
                style: {}
              }, null, 8, _hoisted_6), [
                [_directive_loading, chatLoading.value]
              ]),
              (noMoreChat.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_4)), [
            [_directive_infinite_scroll, loadMoreChatContentList]
          ])
        : (_unref(chatGlobalLoading))
          ? (_openBlock(), _createBlock(loading, {
              key: 1,
              class: "loading loading-flex"
            }))
          : (!_unref(chatGlobalLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
              ]))
            : _createCommentVNode("", true)
    ])
  ])), [
    [_directive_loading, contentLoading.value]
  ])
}
}

})